import { FC } from "react";
import { IconProps } from "./types";

export const SocialFacebookCircle: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      d="M13.354 8.24c-.209 0-.505.104-.505.551v1.19h1.815l-.209 2.023h-1.606v5.727h-2.38v-5.727H9.337V9.981h1.132v-1.31c0-.937.445-2.402 2.401-2.402l1.763.007V8.24h-1.28z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12z"
      fill={fill}
    />
  </svg>
);
